/**
 * CashTrendsTab — spending analysis for ONE account.
 *
 * Phase 86.C: this file no longer calculates anything. It used to run its own
 * Supabase query and group client-side on the RAW amount with no FX conversion,
 * which meant a multi-currency account disagreed with the dashboard's donut for
 * the same transactions. It now renders the shared <SpendingExplorer> scoped to
 * this account, so both views are the same code path with a different scope.
 */
import React from 'react';
import SpendingExplorer from '@/components/spending/SpendingExplorer';

export default function CashTrendsTab({ account, baseCurrency = 'INR' }) {
  return (
    <div className="space-y-4" data-testid="accounts-cash-tab-trends">
      <SpendingExplorer
        accountIds={[account.id]}
        scopeLabel={`${account.name} only`}
        baseCurrency={baseCurrency}
        defaultPeriod="last_30_days"
        testidPrefix="account-spending-explorer"
      />
    </div>
  );
}
